import { render, staticRenderFns } from "./insurance_invoice.vue?vue&type=template&id=6cddbfde&scoped=true&"
import script from "./insurance_invoice.vue?vue&type=script&lang=js&"
export * from "./insurance_invoice.vue?vue&type=script&lang=js&"
import style0 from "./insurance_invoice.vue?vue&type=style&index=0&id=6cddbfde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cddbfde",
  null
  
)

export default component.exports